import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICallPurpose } from "../callpurposeModel";

export const getAllCallPurpose = createAsyncThunk(
  "CallPurpose/FindAllCallPurpose",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/FindAllCallPurpose`,
        {
          call_purpose: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCallPurpose = createAsyncThunk(
  "CallPurpose/FindAllActiveCallPurpose",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CallPurpose/FindAllActiveCallPurpose`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CallPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCallPurpose = createAsyncThunk(
  "CallPurpose/InsertCallPurpose",
  async (CallPurposeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/InsertCallPurpose`,
        CallPurposeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CallPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCallPurpose = createAsyncThunk(
  "CallPurpose/UpdateCallPurpose",
  async (CallPurposeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/UpdateCallPurpose`,
        CallPurposeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CallPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCallPurposeByID = createAsyncThunk(
  "CallPurpose/FindByIDCallPurpose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/FindByIDCallPurpose`,
        { call_purpose_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        call_purpose_guid: result.call_purpose_guid,
        call_purpose: result.call_purpose,
        isactive: result.isactive === true ? 1 : 2,
      } as ICallPurpose;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CallPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const CallPurposeActiveInactive = createAsyncThunk(
  "CallPurpose/ActiveInActiveCallPurpose",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/ActiveInActiveCallPurpose`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CallPurpose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCallPurpose = createAsyncThunk(
  "CallPurpose/DeleteCallPurpose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CallPurpose/DeleteCallPurpose`,
        { call_purpose_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting typeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
